<template>
  <div class="service-detail-container">
    <div class="service-close-container">
      <button
        type="button"
        @click="close"
      >
        <img
          src="../../../assets/img/service/X.svg"
          alt="Edit"
          class="service-close-icon"
        >
      </button>
      <div class="service-close">
        Close
      </div>
    </div>
    <fragment v-if="!loadingDetail">
      <ServiceRequestCard
        isDetailView
        :serviceItem="serviceInfo"
      />
      <div class="grid-column auto gap-32 margin-top-48">
        <div>
          <div class="sac__font-32 f-white semi-bold margin-bottom-24">
            Service Details
          </div>
          <div class="grid-row gap-16">
            <ConfirmRequest :serviceItem="sr" />
            <ServiceDetailSummary :serviceItem="sr" />
            <div v-if="closedStatus.includes(sr.serviceStatus)" class="resolution-section">
              <div class="grid-column ai-s jc-s gap-16">
                <img
                  src="@shared/assets/img/service/pencil-edit.svg"
                  class="img-size-16"
                >
                <div>
                  <div class="sac__font-16 f-white semi-bold">
                    Resolution note:
                  </div>
                  <div class="sac__font-16 f-white">
                    {{ sr.workPerformed }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ServiceNotes :serviceItem="sr" />
      </div>
      <ServiceItems />
    </fragment>
    <div v-else class="loading-container">
      <img
        src="../../../assets/img/general/loading-white.svg"
        class="img-size-24"
        alt="Edit"
      >
    </div>
  </div>
</template>
<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import ServiceRequestCard from '@shared/components/service/ServiceRequestCard.vue';
import ServiceDetailSummary from '../serviceDetail/ServiceDetailSummary.vue';
import ServiceNotes from '../shared/ServiceNotes.vue';
import ServiceItems from '../shared/ServiceItems.vue';
import ConfirmRequest from '../serviceDetail/ConfirmRequest.vue';

export default {
  name: 'ServiceDetail',
  components: {
    ServiceRequestCard,
    ConfirmRequest,
    ServiceDetailSummary,
    ServiceNotes,
    ServiceItems,
  },
  mixins: [serviceMixin],
  props: {
    sr: Object,
    close: Function,
  },
  mounted() {
    if (this.sr.alertNoticeId) {
      this.$store.dispatch('getLeadDetail', { noticeId: this.sr.alertNoticeId });
    }
    if (this.sr.customerId) {
      this.$store.dispatch('getComfortCreditBalance', this.sr.customerId)
    }
  },
};
</script>
<style lang="scss" scoped>
.service-detail-container {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: $BLACK;
  height: 100%;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  .service-close-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px 0;
    .service-close-icon {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .service-close{
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      text-align: right;
      color: $WHITE;
    }
  }
  .resolution-section {
    background-color: $N90;
    border-radius: 8px;
    padding: 16px;
  }
}
</style>
